import { injectable } from "inversify";
import DataFilterBaseHandler from "./DataFilterBaseHandler";
import IDataFilterStateHandler from "./IDataFilterStateHandler";

@injectable()
export default class DataFilterStateHandler extends DataFilterBaseHandler implements IDataFilterStateHandler
{
  constructor() {
    super();
  }
}
